// extracted by mini-css-extract-plugin
export default {"InlineLoader":"loader_InlineLoader__LVjk3","Text":"loader_Text__4YJcl","PageLoader":"loader_PageLoader__RxAcs"};